import React from "react";
import { RedeemPointContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { toast } from "react-toastify";
import { MdEdit, MdHelpOutline, MdUploadFile } from "react-icons/md";
import { Buttons, Displays, Inputs, Modals, Tables } from "components";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment-timezone";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import {
  RENDER_SHIPPING_STATUS,
  SHIPPING_STATUS_FILTER_OPTIONS,
  SHIPPING_STATUS_LABEL,
  SHIPPING_STATUS_SETTABLE,
  SHIPPABLE_REWARD_TYPE,
} from "utils/functions/shipping";
import {
  ShippingStatusContainer,
  ShippingStatusUploadContainer,
} from "./Modals";

// จำว่าเคยอ่านคำแนะนำแล้ว เก็บในเครื่องผู้ใช้ ไม่ต้องยุ่งกับ api หรือ redux
const HELP_SEEN_KEY = "redeem_point_shipping_help_seen";

// คีย์ที่ยอมให้อยู่บน url ได้ (กันค่าแปลกปลอมหลุดเข้าไปใน query ที่ยิง api)
// status ไม่อยู่ในนี้ เพราะหน้านี้บังคับ status=2 เสมอ ไม่ให้ผู้ใช้เปลี่ยน
const FILTER_FIELDS = [
  "customer_user_id",
  "customer_cu_id",
  "reward_type",
  "reward_name",
  "shipping_status",
  "start_date",
  "end_date",
];

// แปลง query string ของ url เป็น state ของ filter
// ใช้ตอนเข้าหน้าครั้งแรก กด refresh หรือกดย้อนกลับมาที่หน้านี้
const parseUrlQuery = (search) => {
  const searchParams = new URLSearchParams(search || "");
  const currentPage = Number(searchParams.get("page")) || 1;
  let filterValues = {};
  FILTER_FIELDS.forEach((key) => {
    filterValues[key] = searchParams.get(key) || "";
  });
  Array.from(searchParams.keys()).forEach((key) => {
    if (FILTER_FIELDS.indexOf(key) === -1 || !searchParams.get(key)) {
      searchParams.delete(key);
    }
  });
  const filterString = searchParams.toString();
  return {
    filterQuery: filterString ? `?${filterString}` : "",
    filterValues,
    currentPage,
  };
};

class RedeemPointContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    data: [],
    // ใช้บังคับให้ InputFilter สร้างใหม่ตอนกดล้างค่า (ค่าในช่องเป็น state ภายในของมันเอง)
    filterKey: 0,
    // เปิดค้างไว้ครั้งแรกที่เข้าใช้ เพื่อให้คนที่ยังไม่เคยใช้เห็นว่ามีอะไรให้ทำบ้าง
    // พอกดปิดแล้วจำไว้ คนที่ใช้ทุกวันจะไม่ถูกรบกวนอีก
    isShowHelp: localStorage.getItem(HELP_SEEN_KEY) !== '1',
    // อ่าน filter กับเลขหน้าจาก url ตั้งแต่ตอนสร้าง state
    // เพื่อให้ refresh หรือย้อนกลับมาแล้วยังอยู่ที่เดิม
    ...parseUrlQuery(this.props.router.location.search),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;

    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, this.state.perPage, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_REWARD_HISTORY_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      // ต้องปิด loading ทุกกรณี ไม่งั้นหน้าค้างที่ spinner ตลอดไปโดยไม่บอกอะไรเลย
      // เคสที่เจอบ่อยคือ token หมดอายุแล้วได้ 403 กลับมา
      this.setState({ data: [], isLoading: false, pagination: null });
      toast.error(
        res && res.status === 403
          ? 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่'
          : 'โหลดข้อมูลไม่สำเร็จ'
      );
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    // ล้างค่าที่ไม่อยู่ใน FILTER_FIELDS ทิ้งก่อนเสมอ แล้วกลับไปหน้า 1
    const parsed = parseUrlQuery(e);
    this.setState({ ...parsed, currentPage: 1 });
    this.handleJoinQuery(parsed.filterQuery, perPage, 1);
  };

  handleClearFilter = () => {
    const { perPage } = this.state;
    this.setState((prev) => ({
      ...parseUrlQuery(''),
      // เปลี่ยน key เพื่อบังคับสร้าง InputFilter ใหม่ ค่าในช่องจะได้ว่างจริง
      filterKey: prev.filterKey + 1,
    }));
    this.handleJoinQuery('', perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    // status=2 ต่อท้ายเสมอและไม่เอาขึ้น url เพราะหน้านี้ดูเฉพาะการแลกที่สำเร็จ
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}&status=2`
      : `?limit=${per_page}&page=${page}&status=2`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    this.handleSyncUrlQuery(query, page);
    this.fetchData(joinQuery);
  };

  // เขียน filter กับเลขหน้าลง url เพื่อให้ refresh / ย้อนกลับ / แชร์ลิงก์ แล้วได้ผลเดิม
  // replace:true เพื่อไม่ให้ทุกการกดหน้าไปกองอยู่ในประวัติเบราว์เซอร์
  handleSyncUrlQuery = (query, page) => {
    const searchParams = new URLSearchParams(query || '');
    Array.from(searchParams.keys()).forEach((key) => {
      if (!searchParams.get(key)) {
        searchParams.delete(key);
      }
    });
    if (page > 1) {
      searchParams.set('page', page);
    }
    const search = searchParams.toString();
    this.props.router.navigate(
      { search: search ? `?${search}` : '' },
      { replace: true }
    );
  };

  // โหลดหน้าเดิมซ้ำหลังแก้สถานะ ไม่เด้งกลับหน้าแรก
  handleReloadCurrentPage = () => {
    const { filterQuery, perPage, currentPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, currentPage);
  };

  handleCloseModal = () => {
    this.setState({ renderModal: false });
  };

  handleClickEditShipping = (row) => {
    this.setState({
      renderModal: (
        <ShippingStatusContainer
          data={row}
          onSuccess={this.handleUpdateShippingSuccess}
          onCancel={this.handleCloseModal}
        />
      ),
    });
  };

  handleClickBulkShipping = () => {
    this.setState({
      renderModal: (
        <ShippingStatusUploadContainer
          onUpdated={this.handleReloadCurrentPage}
          onCancel={this.handleCloseModal}
        />
      ),
    });
  };

  handleUpdateShippingSuccess = () => {
    this.handleCloseModal();
    this.handleReloadCurrentPage();
  };

  handleToggleHelp = () => {
    const next = !this.state.isShowHelp;
    this.setState({ isShowHelp: next });
    // จำเฉพาะตอนกดปิด ถ้าเปิดดูอีกครั้งก็ไม่ต้องรีเซ็ตอะไร
    if (!next) localStorage.setItem(HELP_SEEN_KEY, "1");
  };

  renderHelp = () => {
    const { isShowHelp } = this.state;
    return (
      <div className="help_panel">
        <div className="help_head" onClick={this.handleToggleHelp}>
          <MdHelpOutline size={18} />
          <span className="help_head_text">
            วิธีอัปเดตสถานะการจัดส่ง
          </span>
          <span className="help_toggle">
            {isShowHelp ? "ซ่อน" : "ดูวิธีใช้"}
          </span>
        </div>
        {isShowHelp && (
          <div className="help_body">
            <div className="help_col">
              <div className="help_col_title">แก้ทีละรายการ</div>
              <div>
                กดไอคอน <MdEdit size={14} /> ที่คอลัมน์ "แก้ไข" ท้ายตาราง
                เลือกสถานะแล้วกดบันทึก
              </div>
            </div>
            <div className="help_col">
              <div className="help_col_title">แก้ทีละหลายรายการ</div>
              <div>
                กด Export → กรอกคอลัมน์ <b>"สถานะใหม่"</b> ในไฟล์ →
                กดปุ่ม <b>"อัปเดตสถานะจากไฟล์"</b> เพื่ออัปโหลดกลับ
                (ในไฟล์มี sheet "วิธีใช้" อธิบายไว้ด้วย)
              </div>
            </div>
            <div className="help_col">
              <div className="help_col_title">สถานะที่ใช้ได้</div>
              <div>
                {SHIPPING_STATUS_SETTABLE.map((e) => SHIPPING_STATUS_LABEL[e]).join(
                  " · "
                )}
              </div>
              <div className="help_dim">
                "จัดส่งไม่สำเร็จ" และ "ยกเลิก" ต้องระบุเหตุผลด้วย
              </div>
            </div>
            <div className="help_note_row">
              <b>"{SHIPPING_STATUS_LABEL["9"]}"</b> คือรายการที่แลกก่อนเริ่มใช้ระบบนี้
              ซึ่งไม่มีการบันทึกข้อมูลการจัดส่งไว้ —{" "}
              <b>ไม่ใช่งานที่ค้างอยู่</b> ถ้าต้องการตามของเก่าก็แก้เป็นสถานะปกติได้
              <br />
              การตั้ง "ยกเลิก" เป็นการบันทึกสถานะการจัดส่งเท่านั้น{" "}
              <b>ไม่มีการคืนแต้มและไม่คืนสต็อก</b> · รายการ E-coupon
              ไม่มีการจัดส่งจึงกำหนดสถานะไม่ได้
            </div>
          </div>
        )}
      </div>
    );
  };

  renderRewardType = (e) => {
    switch (e) {
      case "1":
        return "E-coupon";
      case "2":
        return "Coupon";
      case "3":
        return "Other";
      default:
        break;
    }
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false&status=2`
      : `?pagination=false&status=2`;
    let res = await portalService.GET_REWARD_HISTORY_LIST(joinQuery);
    if (res && res.status === 200) {
      var wb = XLSX.utils.book_new();
      var ws_name = "SheetJS";
      // ⚠️ สามชุดนี้ต้องยาวเท่ากันเสมอ (ปัจจุบัน 20 ช่อง)
      // แถวข้อมูล / หัวตาราง / ความกว้างคอลัมน์ ถ้าแก้ต้องแก้พร้อมกันทั้งสามที่
      // ไม่งั้นข้อมูลจะเหลื่อมทั้งไฟล์โดยไม่มีอะไรฟ้อง
      /* make worksheet */
      var ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          e.customer_user_id,
          moment(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm:ss"),
          e.customer_cu_id,
          this.renderRewardType(e.reward_type),
          e.reward_code,
          e.reward_name,
          moment(e.reward_expire).tz("Asia/Bangkok").format("DD/MM/YYYY"),
          RenderCommaMoney(Number(e.reward_redeem_amount), true),
          RenderCommaMoney(Number(e.reward_cost), true),
          RenderCommaMoney(Number(e.reward_redeem_point), true),
          e.name_shipping,
          e.phone_shipping,
          e.address_shipping,
          RENDER_SHIPPING_STATUS(e.shipping_status, e.reward_type) || "-",
          // "สถานะใหม่" เว้นว่างเสมอ เป็นช่องให้ผู้ใช้กรอกแล้วอัปกลับ
          "",
          e.shipping_status_reason || "",
          e.shipping_status_admin_username || "",
          e.shipping_status_updated_at
            ? moment(e.shipping_status_updated_at)
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY HH:mm")
            : "",
          // บังคับเป็น string กัน SheetJS/Excel ตีความ ObjectId ที่เป็นเลขล้วน
          // เป็นตัวเลขแล้วกลายเป็น 6.54321E+21 ทำให้รหัสเพี้ยนถาวร
          String(e._id),
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        "No",
        "Login ID",
        "Created at",
        "CU code",
        "Redeem type",
        "Coupon code",
        "Coupon name",
        "Expired date",
        "Qty",
        "Coupon cost",
        "Redeem point",
        "Receiver Name",
        "Tel",
        "Address",
        "สถานะการจัดส่ง",
        "สถานะใหม่",
        "เหตุผล",
        "อัปเดตโดย",
        "อัปเดตเมื่อ",
        "Ref ID",
        // 'Total received point',
        // 'Remaining point',
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wscols = [
        { wch: 5 },
        { wch: 35 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 22 },
        { wch: 22 },
        { wch: 40 },
        { wch: 16 },
        { wch: 18 },
        { wch: 26 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.utils.book_append_sheet(wb, this.buildHowToSheet(), "วิธีใช้");
      XLSX.writeFile(
        wb,
        `Redeem point report ${moment()
          .tz("Asia/Bangkok")
          .format("DD-MM-YYYY")}.xlsx`
      );
    } else {
      toast.error(
        res && res.status === 403
          ? "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่"
          : "Export ไม่สำเร็จ"
      );
    }
    // reset นอก if เสมอ ไม่งั้น export ที่ล้มเหลวจะทิ้ง loading ค้างทับจอถาวร
    this.setState({
      isBgLoading: false,
    });
  };

  // sheet อธิบายวิธีใช้ ให้ผู้ใช้ copy ข้อความสถานะไปวางได้เลย
  // ไม่โชว์รหัสตัวเลข เพราะพิมพ์เลขผิดจะผ่าน validation แต่ได้ข้อมูลผิดแบบเงียบ
  // ส่วนพิมพ์ภาษาไทยผิดจะถูกตีกลับทันที
  buildHowToSheet = () => {
    const rows = [
      ["วิธีอัปเดตสถานะการจัดส่ง"],
      [""],
      ['1. กรอกเฉพาะคอลัมน์ "สถานะใหม่" เท่านั้น'],
      ["   แถวที่ไม่ต้องการเปลี่ยน ให้เว้นว่างไว้"],
      ['2. ห้ามแก้คอลัมน์ "Ref ID" และ "สถานะการจัดส่ง"'],
      ["3. แก้คอลัมน์อื่น (ชื่อ ที่อยู่ เบอร์โทร) จะไม่มีผลกับระบบ"],
      ["4. บันทึกเป็น .xlsx แล้วอัปโหลดกลับที่หน้า Redeem point"],
      [""],
      ['ค่าที่ใส่ได้ในช่อง "สถานะใหม่"  (copy ไปวางได้เลย)'],
      ["สถานะ", "เหตุผล"],
      ...SHIPPING_STATUS_SETTABLE.map((e) => [
        SHIPPING_STATUS_LABEL[e],
        ["4", "5"].indexOf(e) > -1 ? "ต้องใส่" : "ไม่ต้องใส่",
      ]),
      [""],
      ["หมายเหตุ"],
      ['· "ยกเลิก" บันทึกสถานะเท่านั้น ไม่คืนแต้มและไม่คืนสต็อก'],
      ["· รายการ E-coupon ไม่มีการจัดส่ง กำหนดสถานะไม่ได้"],
      [
        '· ถ้าเปลี่ยนไปเป็นสถานะที่ไม่ต้องใช้เหตุผล ไม่ต้องลบเหตุผลเดิมเอง ระบบล้างให้',
      ],
      ["· ถ้ามีแถวใดกรอกผิด ระบบจะไม่บันทึกทั้งไฟล์"],
      ["· อัปโหลดไฟล์เดิมซ้ำได้ ระบบจะข้ามรายการที่อัปเดตไปแล้ว"],
    ];
    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws["!cols"] = [{ wch: 30 }, { wch: 16 }];
    return ws;
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      pagination,
      data,
      renderModal,
      filterKey,
      filterValues,
    } = this.state;

    return (
      <RedeemPointContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {this.renderHelp()}
        {/* วางนอก InputFilter เพราะ InputFilter เรนเดอร์ปุ่ม Export ของตัวเองอยู่แล้ว */}
        <div className="btn_bulk">
          <Buttons.BgIconPrefix
            label="อัปเดตสถานะจากไฟล์"
            icon={<MdUploadFile size={18} />}
            onClick={this.handleClickBulkShipping}
          />
        </div>
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="470px" />
        ) : (
          <Tables.Standard
            columns={columns({
              handleClickEditShipping: this.handleClickEditShipping,
            })}
            data={data}
            showPagination
            pagination={pagination}
            handlePageClick={this.handlePageClick}
          />
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RedeemPointContainerStyled>
    );
  }
}

// รับ filterValues เข้ามาเพื่อเติมค่าเดิมกลับเข้าช่อง
// ไม่งั้นพอ refresh หรือย้อนกลับมา ข้อมูลกรองถูกแต่ช่องค้นหาโล่ง ผู้ใช้จะงง
const dataFilter = (filterValues = {}) => [
  {
    accessor: "customer_user_id",
    length: "311px",
    filter: {
      fieldQuery: "customer_user_id",
      type: "text",
      defaultValue: filterValues.customer_user_id,
      label: "Select User : ",
      placeholder: "User ID",
    },
  },
  {
    accessor: "customer_cu_id",
    length: "200px",
    filter: {
      fieldQuery: "customer_cu_id",
      type: "text",
      defaultValue: filterValues.customer_cu_id,
      label: "CU code : ",
      placeholder: "CU code",
    },
  },
  {
    accessor: "reward_type",
    length: "311px",
    filter: {
      fieldQuery: "reward_type",
      type: "dropdown",
      defaultValue: filterValues.reward_type,
      options: [
        {
          label: "All",
          value: "0",
        },
        {
          label: "E-coupon",
          value: "1",
        },
        {
          label: "Coupon",
          value: "2",
        },
        {
          label: "Other",
          value: "3",
        },
      ],
      placeholder: "Redeem type",
      label: "Redeem type : ",
    },
  },
  {
    accessor: "reward_name",
    length: "311px",
    filter: {
      fieldQuery: "reward_name",
      type: "text",
      defaultValue: filterValues.reward_name,
      label: "Coupon name : ",
      placeholder: "Coupon name",
    },
  },
  {
    accessor: "shipping_status",
    length: "311px",
    filter: {
      fieldQuery: "shipping_status",
      type: "dropdown",
      defaultValue: filterValues.shipping_status,
      options: SHIPPING_STATUS_FILTER_OPTIONS,
      placeholder: "สถานะการจัดส่ง",
      label: "สถานะการจัดส่ง : ",
    },
  },
  {
    accessor: "date",
    filter: {
      fieldQuery: "date",
      type: "dateRank",
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: "Date Range : ",
    },
  },
];

const columns = ({ handleClickEditShipping }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Login ID</div>,
    accessor: "customer_user_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Created at</div>,
    accessor: "created_at",
    Cell: (props) =>
      moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>CU code</div>,
    accessor: "customer_cu_id",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Redeem type</div>,
    accessor: "reward_type",
    Cell: (props) => {
      switch (props.value) {
        case "1":
          return "E-coupon";
        case "2":
          return "Coupon";
        case "3":
          return "Other";
        default:
          break;
      }
    },
  },
  {
    Header: <div style={{ textAlign: "left" }}>Coupon code</div>,
    accessor: "reward_code",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Coupon name</div>,
    accessor: "reward_name",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Expired date</div>,
    accessor: "reward_expire",
    Cell: (props) => (
      <div>{moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY")}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Qty</div>,
    accessor: "reward_redeem_amount",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Coupon cost</div>,
    accessor: "reward_cost",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "right" }}>Redeem point</div>,
    accessor: "reward_redeem_point",
    Cell: (props) => (
      <div style={{ textAlign: "right" }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Receiver Name</div>,
    accessor: "name_shipping",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Tel</div>,
    accessor: "phone_shipping",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Address</div>,
    accessor: "address_shipping",
  },
  {
    Header: <div style={{ textAlign: "left" }}>สถานะการจัดส่ง</div>,
    accessor: "shipping_status",
    // ต้องส่ง reward_type ไปด้วย ไม่งั้น e-coupon จะขึ้น "รอดำเนินการจัดส่ง"
    // ทั้งที่ไม่มีการจัดส่ง ทำให้ยอดงานค้างพองเกินจริง
    Cell: (props) =>
      RENDER_SHIPPING_STATUS(props.value, props.row.original.reward_type) ||
      "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>เหตุผล</div>,
    accessor: "shipping_status_reason",
    Cell: (props) => props.value || "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>อัปเดตโดย</div>,
    accessor: "shipping_status_admin_username",
    Cell: (props) => props.value || "-",
  },
  {
    Header: <div style={{ textAlign: "center" }}>แก้ไข</div>,
    accessor: "action_shipping",
    Cell: (props) =>
      // e-coupon ไม่มีการจัดส่ง จึงไม่มีปุ่มแก้ (backend reject อยู่แล้วอีกชั้น)
      SHIPPABLE_REWARD_TYPE.indexOf(props.row.original.reward_type) === -1 ? (
        <></>
      ) : (
        <div
          style={{ textAlign: "center", cursor: "pointer" }}
          onClick={() => handleClickEditShipping(props.row.original)}
        >
          <MdEdit size={20} />
        </div>
      ),
  },
  // {
  //   Header: <div style={{ textAlign: 'right' }}>Total received point</div>,
  //   accessor: 'total_received_point',
  //   Cell: (props) => (
  //     <div style={{ textAlign: 'right' }}>
  //       {RenderCommaMoney(Number(props.value), true)}
  //     </div>
  //   ),
  // },

  // {
  //   Header: <div style={{ textAlign: 'right' }}>Remaining point</div>,
  //   accessor: 'remaining_point',
  //   Cell: (props) => (
  //     <div style={{ textAlign: 'right' }}>
  //       {RenderCommaMoney(Number(props.value), true)}
  //     </div>
  //   ),
  // },
];

export default withRouter(RedeemPointContainer);
